import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
  {
    variable: "name",
    title: "Name",
    hidden: false,
    type: "string",
    field: "name",
  },
  {
    variable: "loadBalancingScheme",
    title: "Load Balancing Scheme",
    hidden: false,
    type: "string",
    field: "loadBalancingScheme",
  },
  {
    variable: "region",
    title: "Region",
    hidden: false,
    type: "string",
    field: "region",
  },
  {
    variable: "network",
    title: "Network",
    hidden: false,
    type: "string",
    field: "network",
  },
  {
    variable: "protocol",
    title: "protocol",
    hidden: false,
    type: "string",
    field: "protocol",
  },
  {
    variable: "healthChecks",
    title: "Health Checks",
    hidden: false,
    type: "number",
    field: "healthChecks",
  },
  {
    variable: "backends",
    title: "Backends ",
    hidden: false,
    type: "number",
    field: "backends",
  },
];

const NETWORK_TYPE = [
  { value: 'network in this project', name: 'Network in this project' },
  { value: 'network shared with me', name: 'Network shared with me ' },

]

class LoadBalancerDataService {
  constructor() {
    // we only need one of these
    if (!LoadBalancerDataService.instance) {
      LoadBalancerDataService.instance = this;
    }
    this.searchPlaceholder = 'Search Load Balancer';
    this.fields = fields;


    this.getLoadBalancers = () => {
      return FetchAPI({
        url: 'system/gcp/aggregated/backend-services',
        method: 'GET'
      });
    }

    this.getFrontendServices = () => {
      return FetchAPI({
        url: 'system/gcp/aggregated/frontend-services',
        method: 'GET'
      });
    }

    this.getFrontendServicesList = (region) => {
      return FetchAPI({
        url: `system/gcp/frontend-services/${region}`,
        method: 'GET'
      })
    }

    this.getFrontendServicesByName = (name) => {
      return FetchAPI({
        url: `system/gcp/frontend-services/${name}`,
        method: 'GET'
      })
    }


    this.createRegionBackend = (region, body) => {
      return FetchAPI({
        url: `system/gcp/backend-services/${region}`,
        method: 'POST',
        body: body
      })
    }

    this.getRegionBackend = (region, name) => {
      return FetchAPI({
        url: `system/gcp/backend-services/${region}/${name}`,
        method: 'GET'
      })
    }

    this.getbackendsByRegion = (region) => {
      return FetchAPI({
        url: `system/gcp/region-backend-services/${region}`,
        method: 'GET'
      })
    }


    this.patchBackendService = (region, name, body) => {
      return FetchAPI({
        url: `system/gcp/backend-services/${region}/${name}`,
        method: 'PUT',
        body: body
      })
    }

    this.getHealthChecks = () => {
      return FetchAPI({
        url: 'system/gcp/health-checks',
        method: 'GET',
      });
    }

    this.deleteBackendService = (region, name) => {
      return FetchAPI({
        url: `system/gcp/backend-services/${region}/${name}`,
        method: 'DELETE'
      })
    }


    this.createForwardingRule = (region, body) => {
      return FetchAPI({
        url: `system/gcp/frontend-services/${region}`,
        method: 'POST',
        body: body
      })
    }

    this.patchForwardingRule = (region, name, body) => {
      return FetchAPI({
        url: `system/gcp/frontend-services/${region}/${name}`,
        method: 'PUT',
        body: body
      })
    }


    this.deleteForwardingRule = (region, name) => {
      return FetchAPI({
        url: `system/gcp/frontend-services/${region}/${name}`,
        method: 'DELETE'
      })
    }

    return LoadBalancerDataService.instance;
  }
}

const LoadBalancerService = new LoadBalancerDataService();

export {
  LoadBalancerService as default,
  fields as LoadBalancerFields,
  NETWORK_TYPE,
};
